import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { AppLayout } from '@/components/AppLayout';
import { NAV_ITEMS, filterNavByRole, filterNavByRechte } from '@/config/navigation';
import { useZugang } from '@/hooks/useZugang';
import { ChevronRight } from 'lucide-react';

export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Kacheln = dieselbe Nav-Quelle wie Sidebar/Bottom-Bar, ohne „Start" selbst.
  const { rechte, geladen, laedt, fachbereich } = useZugang();
  const tiles = filterNavByRechte(filterNavByRole(NAV_ITEMS, user?.role), rechte, geladen, fachbereich)
    .filter((t) => t.path !== '/home');

  const getFirstName = () => {
    if (!user?.name) return '';
    return user.name.split(' ')[0];
  };

  return (
    <AppLayout title="Start">
      <div className="max-w-6xl mx-auto px-4 pt-6 pb-8">
        {/* Begrüßung */}
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-foreground">
            Hallo{getFirstName() ? `, ${getFirstName()}` : ''}!
          </h1>
          <p className="text-sm text-muted-foreground">Was möchtest du tun?</p>
        </div>

        {/* Kachel-Grid — responsiv 2 → 3 → 4 Spalten.
            Beim Kaltstart stehen hier Platzhalter in Kachelgroesse: es blitzt
            nichts auf, was jemand nicht sehen darf, und nichts springt, wenn
            die Rechte da sind. Schlaegt das Laden fehl, gilt Fail-open und es
            stehen wie bisher alle Kacheln da. */}
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4" aria-busy={laedt}>
          {laedt &&
            Array.from({ length: 6 }, (_, i) => (
              <div
                key={i}
                aria-hidden
                className="rounded-2xl bg-muted animate-pulse min-h-[140px]"
              />
            ))}
          {!laedt && tiles.map((tile) => {
            const Icon = tile.icon;
            const isTextLight = tile.colorClass.includes('gradient') || tile.colorClass === 'bg-primary';
            return (
              <button
                key={tile.path}
                onClick={() => navigate(tile.path)}
                className={`${tile.colorClass} relative rounded-2xl p-5 text-left transition-all active:scale-[0.98] shadow-sm hover:shadow-md flex flex-col justify-between min-h-[140px] group`}
              >
                <div className={isTextLight ? 'text-white' : 'text-foreground'}>
                  <Icon className="w-8 h-8" />
                </div>
                <div className="mt-auto">
                  <h2 className={`font-semibold text-base ${isTextLight ? 'text-white' : 'text-foreground'}`}>
                    {tile.label}
                  </h2>
                  <p className={`text-xs mt-0.5 ${isTextLight ? 'text-white/70' : 'text-muted-foreground'}`}>
                    {tile.description}
                  </p>
                </div>
                <ChevronRight
                  className={`absolute bottom-3 right-3 w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity ${
                    isTextLight ? 'text-white/70' : 'text-muted-foreground'
                  }`}
                />
              </button>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
}
